var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionnaire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-128 -911)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: "0.4px",
    stroke: "currentColor",
    d: "M4.078-2.524q-.009-.314-.009-.471a4.391,4.391,0,0,1,.262-1.6,3.633,3.633,0,0,1,.619-1.02A11.74,11.74,0,0,1,6.079-6.7,5.332,5.332,0,0,0,7.138-7.851a1.848,1.848,0,0,0,.244-.933,2.175,2.175,0,0,0-.715-1.609,2.422,2.422,0,0,0-1.753-.693,2.357,2.357,0,0,0-1.674.628A3.307,3.307,0,0,0,2.36-8.5L.747-8.688a4.169,4.169,0,0,1,1.295-2.738,4.145,4.145,0,0,1,2.847-.95,4.261,4.261,0,0,1,2.991,1.02A3.223,3.223,0,0,1,9-8.889,3.125,3.125,0,0,1,8.6-7.346,7.315,7.315,0,0,1,7.068-5.628a7.77,7.77,0,0,0-1,1,2.235,2.235,0,0,0-.349.741,6.209,6.209,0,0,0-.131,1.36ZM3.982.624V-1.164H5.769V.624Z",
    transform: "translate(134.953 928.876)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2px",
    transform: "translate(128 911)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "none",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 12,
    cy: 12,
    r: 11
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.96b43f09.svg";
export { ForwardRef as ReactComponent };